/**
 * Function that receive an entity list and the entity
 * id that will be searched and returned.
 * @param entityList => Entity array (Temporalically any type)
 * @param id => Entity id
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function findById(entityList: any[], id: string | number): object {
  const result = entityList.find((entity) => entity.id === id);

  return result ?? {};
}

export default findById;
